/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const assignUserRoleResponseDataRoleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type AssignUserRoleResponseDataRoleSchema = z.infer<typeof assignUserRoleResponseDataRoleSchema>
